/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ShieldIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABnElEQVR4nM2Uu0oDURCGN6UgCl4qa0GNeGmtFEEiu3NJ4GRmFRV8DLGwVSufQbASvKCFhSAi+BRBjIqFgiIWYkAlmoSNycmumxT+MM0y5/9mzs4cx/kPMsZ0AukGst7+hKynUvMdLTEn8gFY88j6WRWk94jZRcdxErGM3Yzfj6QnNcY1IDlDNEORjY0xbUCyhqxvQSNguStWXA8CJO9AsmWMaW9oDqBJYL36fRhZN8uHQ7rJMcugFYCkl9VV67mbzg5X5YRemV7YAayFgPlSvR8YCmAtNAJUEqPkoCWiAhItBwDrSznJGNMVBwCkz40AlQkqTlSsDkhyDQByHKd9ZF0O7MuBFYCsq3EAQHIU2JsVewegyb8CXNf0Bbfey/gDVkC9ZcMQAJLsRFqysjyWmagAj2UWWT8q1ZNMhwK+r4rlMAxAJBPI8hqoft+JqpQxvUByYwMgahpYngLPSt7z/J7IgJLJOJA81pnz7epv8uCms6NOHBHNjdk6KcU1gI44zYh5oRtZ9mrNZdf2nMQSYnYKSU6LQSSTLTNuVl+dute5Z0hrdgAAAABJRU5ErkJggg==)
 */
export const ShieldIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M4.27 5.22A2.66 2.66 0 0 0 3 7.5v2.3c0 5.6 3.3 10.68 8.42 12.95.37.17.79.17 1.16 0A14.18 14.18 0 0 0 21 9.78V7.5c0-.93-.48-1.78-1.27-2.27l-6.17-3.76a3 3 0 0 0-3.12 0L4.27 5.22ZM6 7.68l6-3.66V12H6.22C6.08 11.28 6 10.54 6 9.78v-2.1Zm6 12.01V12h5.78A11.19 11.19 0 0 1 12 19.7Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
